import api from './api';

const qrSessionService = {
    // Create a new QR session (desktop, authenticated)
    createSession: async (mode = 'single') => {
        const response = await api.post('/api/qr-session/create', { mode });
        return response;
    },

    // Poll session status (desktop, authenticated)
    getStatus: async (token) => {
        const response = await api.get(`/api/qr-session/${token}/status`);
        return response;
    },

    // Validate token on mobile page (public, no auth)
    validateToken: async (token) => {
        const response = await api.get(`/api/qr-session/${token}/validate`);
        return response;
    },

    // Cancel session when desktop closes the modal (authenticated)
    cancelSession: async (token) => {
        const response = await api.post(`/api/qr-session/${token}/cancel`);
        return response;
    },

    // Check if desktop has consumed the image (public, no auth)
    checkConsumed: async (token) => {
        const response = await api.get(`/api/qr-session/${token}/mobile-check`);
        return response;
    },

    // Upload image from mobile — single mode (public, no auth)
    // base64: pure base64 string (no data: prefix), mimeType: e.g. 'image/jpeg'
    uploadImage: async (token, base64, mimeType = 'image/jpeg') => {
        const response = await api.post(`/api/qr-session/${token}/upload`, {
            imageData: base64,
            mimeType,
        }, { timeout: 30000 });
        return response;
    },

    // Upload one side of dual image from mobile (public, no auth)
    uploadDualSide: async (token, side, base64, mimeType = 'image/jpeg') => {
        const response = await api.post(`/api/qr-session/${token}/upload?side=${side}`, {
            imageData: base64,
            mimeType,
        }, { timeout: 30000 });
        return response;
    },
};

export default qrSessionService;
